var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3301 15V104.528",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3309 53.8084C88.1217 53.8084 93.6267 48.3034 93.6267 41.5127C93.6267 34.7219 88.1217 29.2169 81.3309 29.2169C74.5402 29.2169 69.0352 34.7219 69.0352 41.5127C69.0352 48.3034 74.5402 53.8084 81.3309 53.8084Z",
    fill: "#FD6533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2969 15V104.528",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2957 61.4934C45.0865 61.4934 50.5915 55.9884 50.5915 49.1976C50.5915 42.4068 45.0865 36.9019 38.2957 36.9019C31.505 36.9019 26 42.4068 26 49.1976C26 55.9884 31.505 61.4934 38.2957 61.4934Z",
    fill: "#FFCD3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8125 104.528V15",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8133 90.3115C66.6041 90.3115 72.1091 84.8065 72.1091 78.0157C72.1091 71.225 66.6041 65.72 59.8133 65.72C53.0226 65.72 47.5176 71.225 47.5176 78.0157C47.5176 84.8065 53.0226 90.3115 59.8133 90.3115Z",
    fill: "#36CCC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotC);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;